import React from 'react'
import {Accordion} from './accordion'

export class Faq extends React.Component {
  state = {active: null}

  setActive = (id) => {
    this.setState({active: id})
  }

  render() {
    return <div className="bg-gray">
      <div className="container grid-lg ndnr-faq">
        <div className="columns">
          <div className="column col-12 mb-2 mt-2">
            <h2 className='text-center'>FAQ</h2>
            <Accordion title="Warum sehe ich nicht die genaue Adresse?" setActive={this.setActive} active={this.state.active} id="accordion-1">
              <p>
                Es geht uns nicht darum, Organisationen zu „outen“ oder bisher geheime Adressen
                öffentlich zu machen. Wir nutzen hauptsächlich öffentlich zugängliche und offizielle
                Adressen für diese Karte. Da manche Organisation nur ein Postfach angibt, sind uns in
                einigen Fällen auch nur die Orte bekannt – nicht jedoch die Straße und die Hausnummer.
                Manchmal finden sich zudem bis zu neun verschiedene Vereine, Stiftungen und Medien,
                die unter einer Adresse gemeldet sind. Grafisch sind diese unterschiedlichen Projekte auf
                einer Deutschlandkarte nur schwer an einer Hausnummer darstellbar, ohne das es
                unüberschaubar wird. Um die Darstellung zu vereinheitlichen, haben wir darum ein grobes
                Zoomlevel gewählt.
              </p>
            </Accordion>

            <Accordion title="Was bedeutet eine Verbindung?" setActive={this.setActive} active={this.state.active} id="accordion-2">
              <p>
                Die Projekte der Neuen Rechten sind auf sehr unterschiedliche Arten miteinander
                verbunden. Wir stellen eine Verbindung nur dann dar, wenn mindestens einer der
                folgenden Aspekte in den vergangenen fünf Jahren erfüllt ist:
              </p>
              <ul>
                <li>Es gibt einen Geldfluss zwischen zwei Organisationen</li>
                <li>Mindestens eine Person ist in beiden Organisationen prägend tätig</li>
                <li>Beide Organisationen tauschen untereinander Personal aus oder teilen sich Mitarbeiter*innen</li>
                <li>Beide Organisationen betreiben ein gemeinsames Projekt</li>
                <li>Beide Organisationen haben sich an gemeinsamen Aktionen beteiligt, etwa an einer Kundgebung oder Petition</li>
                <li>Beide Organisationen nutzen die gleiche Adresse oder Infrastruktur</li>
              </ul>
            </Accordion>

            <Accordion title="Wieso gibt es keine Links zu den Organisationen?" setActive={this.setActive} active={this.state.active} id="accordion-3">
              <p>
                Wir wollen mit der Karte einen Überblick über die geografische Verteilung und Vernetzung der Neuen Rechten in Deutschland verschaffen. Der Atlas der neurechten Projekte soll zur Transparenz beitragen und die Ausbreitung des Milieus darstellen. Für einzelne Initiativen werben, wollen wir nicht.
              </p>
            </Accordion>

            <Accordion title="Wer sind die Neuen Rechten?" setActive={this.setActive} active={this.state.active} id="accordion-4">
              <p>
                Diese Karte zeigt nur das Netzwerk der Neuen Rechten. Andere Phänomene der rechten Szene werden nicht berücksichtigt. Auch nicht die
                Strömung der extremen "alten Rechten" (Umfeld von NPD, NSU, Kameradschaftsszene, Freie Netze, Die Rechte, Der III.Weg, etc.), die schon viel
                länger existiert. Diese Neonazis verehren oft den Nationalsozialismus und Adolf Hitler, vertreten geschichtsrevanchistische Ideen und leugnen
                den Holocaust.
              </p>

              <p>
                Im Gegenteil dazu lehnen die Vertreter*innen der Neuen Rechten diese Überzeugungen ab und setzen sich in Kleidung, Habitus und Lebensstil
                bewußt davon ab. Die Anhänger*innen leugnen weder die Shoah noch die Konzentrationslager, betonen aber lieber die über tausendjährige
                Traditionslinie der Deutschen und wollen die deutsche Geschichte nicht auf den Nationalsozialismus reduziert wissen. Die Neue Rechte entstand
                in den 1960er Jahren in Frankreich (»Nouvelle Droite«), der Begriff tauchte 1964 erstmals auch in Deutschland auf. Im Gegensatz zu den "alten Rechten"
                begründen sie ihre gruppenbezogene Menschenfeindlichkeit nicht mit biologischen Rassismus, sondern mit Kultur und Identität, die reingehalten
                werden solle ("Ethnopluralismus"). Eine ausführliche Beschreibung des Konzeptes der Neuen Rechten gibt es im Buch zur Webseite.
              </p>

              <p>
                Auf dieser Karte haben wir nur Organisationen aufgenommen, die wir eindeutig dem Spektrum der Neuen Rechten zuordnen. Parteien wie Die Rechte, Der III.Weg
                oder die NPD sowie Kameradschaftsstrukturen und Neonazi-Gruppen werden darum hier nicht erwähnt.
              </p>
            </Accordion>

            <Accordion title="Stimmt etwas nicht?" setActive={this.setActive} active={this.state.active} id="accordion-5">
              <p>
                Wir haben über drei Jahre für diese Karte recherchiert und alle Informationen sorgfältig und mehrmals geprüft. Trotzdem können sich Fehler eingeschlichen haben. Fehlt eine Verbindung? Haben wir eine Organisation vergessen? Oder finden Sie, ein Projekt taucht hier zu unrecht auf? Bitte rufen Sie nicht gleich Ihren Anwalt an, sondern schreiben Sie uns: netzwerkneuerechte[at]gmail.com
              </p>
            </Accordion>

            <Accordion title="Erratum" setActive={this.setActive} active={this.state.active} id="accordion-6">
              Soweit wir auf dieser Website formuliert haben, der Frauen für Freiheit e.V. unterstütze den AfD-Frauenmarsch und/oder habe Verbindungen zum Gustav-Stresemann-Stiftung e.V. oder zu Tichys Einblick, halten wir diese Äußerungen nicht aufrecht.
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/faq.js